import React, { FC, useRef } from 'react';
import { IconButton, Stack } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

import { WebhookEndpoint } from '../types/types';
import { Column, DataTable } from '../../../common/DataTable';
import { TruncatedUrlCell } from './TruncatedUrlCell';

type SubscriptionTableProps = {
  /**
   * Webhooks to display
   */
  webhooks: WebhookEndpoint[];
  /**
   * Function to call on delete of a webhook
   */
  onDelete: (webhook: WebhookEndpoint) => void;
  /**
   * Function to call on edit of a webhook
   */
  onEdit: (webhook: WebhookEndpoint) => void;
  readOnly?: boolean;
};

const SubscriptionTable: FC<SubscriptionTableProps> = (props) => {
  const { webhooks, onDelete, onEdit, readOnly = false } = props;
  const tableRef = useRef<HTMLDivElement>(null);

  const columns: Column<WebhookEndpoint>[] = [
    {
      id: 'endpoint',
      headerName: 'Endpoint URL',
      minWidth: 140,
      maxWidth: 240,
      renderCell: (row) => <TruncatedUrlCell url={row.endpoint} />,
    },
    {
      headerName: 'Events',
      id: 'events',
      valueGetter: (row: WebhookEndpoint) => {
        return `${row.eventSubscriptions.length} event${
          row.eventSubscriptions.length === 1 ? '' : 's'
        }`;
      },
    },
    {
      id: 'actions',
      headerName: '',
      align: 'right',

      renderCell: (row: WebhookEndpoint) => {
        if (readOnly) {
          return null;
        }

        return (
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <IconButton onClick={() => onEdit(row)} aria-label="Edit webhook">
              <Edit />
            </IconButton>
            <IconButton onClick={() => onDelete(row)} aria-label="Delete webhook">
              <Delete />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
  return (
    <DataTable
      tableRef={tableRef}
      rows={webhooks}
      columns={columns}
      getRowId={(row) => row.subscriptionId}
    />
  );
};

export default SubscriptionTable;
